// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"97dce314","436":"6b6231b5","453":"f394a27d","501":"0bff0aff","606":"579b00db","925":"8b59909f"}[chunkId] + ".chunk.js";
};